import { namespacedConsts } from '../../jsCore/utils/object'

export const MONTIPLAYER_ACTION_TYPES = namespacedConsts({
  SDK_LOADED: true,
  LOAD_SDK: true,
})

export const loadSdk = _ => ({
  type: MONTIPLAYER_ACTION_TYPES.LOAD_SDK,
})

export const sdkLoaded = _ => ({
  type: MONTIPLAYER_ACTION_TYPES.SDK_LOADED,
})



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/monti/montiplayerActions.js